export default "__VITE_ASSET__CLhuTqke__"